exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper.settings{right:0;overflow-y:auto;-ms-overflow-style:none}.wrapper.settings::-webkit-scrollbar{display:none}.settings-item .level-item{padding:6px}.settings-item .level-right .level-item{margin-right:unset}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a4684040","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/core/structure/settings/Settings.vue
// module id = IHTh
// module chunks = 66